"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartbeatStatusEnum = void 0;
var HeartbeatStatusEnum;
(function (HeartbeatStatusEnum) {
    HeartbeatStatusEnum["Failed"] = "failed";
    HeartbeatStatusEnum["Succeeded"] = "succeeded";
})(HeartbeatStatusEnum = exports.HeartbeatStatusEnum || (exports.HeartbeatStatusEnum = {}));
//# sourceMappingURL=heartbeat-status-enum.js.map